import { Box, Grid2, Typography } from "@mui/material";
import React, { useEffect } from "react";
import img1 from "../../assets/TVfood1.png";
import img2 from "../../assets/TVfood2.png";
import { FetchPickupProgress, FetchPickupReady, fetchDineInProgress, fetchDineInReady } from "../../api/TV.service";
import { useDispatch, useSelector } from "react-redux";
import {
  updatePickupProgress,
  updatePickupReady,
  updateTVDineInProgress,
  updateTVDineInReady,
} from "../../store/slice/Webshop.slice";

const TVWidgetDineIn = () => {
  const dispatch = useDispatch();
  const { key } = useSelector((store) => store?.widgetSettings);
  const { TVDineInProgress, TVDineInReady } = useSelector(
    (store) => store?.Webshop
  );
  const FetchDineInProgress = async (key) => {
    try {
      const response = await fetchDineInProgress(key);
      if (response?.status == 200) {
        dispatch(updateTVDineInProgress(response?.data));
      }
    } catch (error) {
      console.error("error:", error?.message);
    }
  };
  const FetchDineInReady = async (key) => {
    try {
      const response = await fetchDineInReady(key);
      if (response?.status == 200) {
        dispatch(updateTVDineInReady(response?.data));
      }
    } catch (error) {
      console.error("error:", error?.message);
    }
  };

  // useEffect(() => {
  //   FetchDineInProgress(key);
  // }, [key]);
  // useEffect(() => {
  //   FetchDineInReady(key);
  // }, [key]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      FetchDineInProgress(key);
      FetchDineInReady(key);
    }, 15000); // 15000 ms = 15 seconds
  
    // Call once on initial mount
    FetchDineInProgress(key);
    FetchDineInReady(key);
  
    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [key]);
  
  return (
    <Box sx={{ p: 2 }}>
      <Grid2 container spacing={2}>
        <Grid2 size={{ md: 4 }}>
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
              px: 2,
              width: "400px",
              height: "130px",
              backgroundColor: "#F37120",
              borderRadius: "8px",
            }}
          >
            <Box sx={{ width: "75px", height: "75px" }}>
              <img src={img1} style={{ width: "100%", height: "100%" }} />
            </Box>
            <Typography sx={{ color: "#fff", fontSize: "2rem" }}>
              Preparing
            </Typography>
          </Box>
          <Box>
            {TVDineInProgress?.map((item, index) => (
              <Typography
                key={index}
                sx={{
                  px: 2,
                  py: 1,
                  border: "1px dashed #F37120",
                  color: "#00000",
                  width: "120px",
                  textAlign: "center",
                  borderRadius: "6px",
                  mt: 2,
                  mb: 2,
                  backgroundColor: "#FFF8F6",
                }}
              >
                {item}
              </Typography>
            ))}
          </Box>
        </Grid2>

        <Grid2 size={{ md: 4 }}>
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
              width: "400px",
              px: 2,
              height: "130px",
              backgroundColor: "#F37120",
              borderRadius: "8px",
            }}
          >
            <Box sx={{ width: "75px", height: "75px" }}>
              <img src={img2} style={{ width: "100%", height: "100%" }} />
            </Box>

            <Typography sx={{ color: "#fff", fontSize: "2rem" }}>
              Collect
            </Typography>
          </Box>
          <Box>
          {TVDineInReady ?.map((item, index) => (
              <Typography
                key={index}
                sx={{
                  px: 2,
                  py: 1,
                  border: "1px dashed #F37120",
                  color: "#00000",
                  width: "120px",
                  textAlign: "center",
                  borderRadius: "6px",
                  mt: 2,
                  mb: 2,
                  backgroundColor: "#FFF8F6",
                }}
              >
                {item}
              </Typography>
            ))}
     
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default TVWidgetDineIn;
